import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

interface Anchor {
  id: string;
  label: string;
  primary?: boolean;
}

const ANCHORS: Anchor[] = [
  { id: 'equiparacao-hospitalar', label: 'Equiparação Hospitalar', primary: true },
  { id: 'restituicao', label: 'Restituição' },
  { id: 'como-funciona', label: 'Como funciona' },
  { id: 'sobre-taxhealth', label: 'Sobre' },
  { id: 'faq', label: 'FAQ' },
];

/**
 * Sticky secondary nav with in-page anchors. Appears after the user scrolls
 * past the hero on the home page. Highlights "Equiparação Hospitalar" as
 * the primary anchor for SEO and user orientation.
 */
const HomeAnchorNav: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState<string>('equiparacao-hospitalar');

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.6);

      // Detect active anchor
      const offset = 160;
      let current = ANCHORS[0].id;
      for (const a of ANCHORS) {
        const el = document.getElementById(a.id);
        if (el && el.getBoundingClientRect().top <= offset) {
          current = a.id;
        }
      }
      setActive(current);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      aria-label="Navegação rápida"
      className={cn(
        'hidden md:block sticky top-14 md:top-16 z-40 border-b bg-white/90 backdrop-blur-md transition-all duration-300',
        visible
          ? 'opacity-100 translate-y-0 max-h-16'
          : 'opacity-0 -translate-y-2 max-h-0 overflow-hidden pointer-events-none'
      )}
    >
      <div className="container mx-auto max-w-6xl px-3 md:px-6">
        <ul className="flex items-center gap-1 md:gap-2 overflow-x-auto py-2 scrollbar-none">
          {ANCHORS.map((a) => {
            const isActive = active === a.id;
            return (
              <li key={a.id} className="shrink-0">
                <a
                  href={`#${a.id}`}
                  className={cn(
                    'inline-flex items-center whitespace-nowrap px-3 py-1.5 rounded-full text-xs md:text-sm transition-colors min-h-[36px]',
                    a.primary
                      ? isActive
                        ? 'bg-primary text-primary-foreground font-semibold'
                        : 'bg-primary/10 text-primary font-semibold hover:bg-primary/15'
                      : isActive
                        ? 'bg-foreground/10 text-foreground font-medium'
                        : 'text-muted-foreground hover:text-foreground hover:bg-foreground/5'
                  )}
                >
                  {a.label}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default HomeAnchorNav;
